import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcuser.group.item');
import { OnInit, OnDestroy, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { ElementRef, ViewChild } from '@angular/core';
import showdown from 'showdown';

@Component({
    selector: 'wiz-portal-gsdcuser-group-item',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcuser.group.item/view.scss */
/* src/app/portal.gsdcuser.group.item/view.scss: no such file or directory */`],
})
export class PortalGsdcuserGroupItemComponent implements OnInit, OnDestroy {

    constructor(@Inject( Service) public service: Service) { }

    @ViewChild('editor')
    public editorElement: ElementRef;
    public editor: any;

    @Input() group_id: any;
    public group: any = null;
    public community: any = null;
    public users: any = [];

    public pagination: any = {
        page: 1,
        end: 1,
        start: 1
    }
    public searchTerm: any = "";
    public total = 0;

    public async ngOnInit() {
        await this.service.init();
        await this.load();
        await this.groupUsers();
    }

    public async load() {
        const { code, data } = await wiz.call("info", { id: this.group_id });
        if (code != 200) return window.location = "/dashboard";
        this.group = data.info;
        this.community = data.community;
        await this.service.render();
    }

    public async groupUsers() {
        const { code, data } = await wiz.call("groupUsers", {
            groupID: this.group_id,
            communityID: this.community.id,
            page: this.pagination.page,
            text: this.searchTerm
        });
        if (code != 200) return await this.service.alert.error("Error!");
        this.users = data.rows;
        this.pagination.start = Math.floor((this.pagination.page - 1) / 10) * 10 + 1;
        this.pagination.end = data.lastpage;
        this.total = data.total;
        await this.service.render();
    }

    public showdown(text) {
        const markdown = typeof text === 'string' ? text : '';
        let converter = new showdown.Converter();
        return converter.makeHtml(markdown);
    }

    private async pageLoad(p: number) {
        this.pagination.page = p;
        await this.groupUsers();
    }
}

export default PortalGsdcuserGroupItemComponent;